'use strict';

var _nodeResolve_empty = require('./_node-resolve_empty.js');
var _commonjsHelpers = require('./_commonjsHelpers.js');

function _interopNamespaceDefaultOnly (e) { return { __proto__: null, 'default': e }; }

var _nodeResolve_empty__namespace = /*#__PURE__*/_interopNamespaceDefaultOnly(_nodeResolve_empty);

var require$$0 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(_nodeResolve_empty__namespace);

module.exports = require$$0;
